import {
  faCalendar,
  faFileUpload,
  faUsers,
} from '@fortawesome/free-solid-svg-icons'
import {
  faCalendarCheck,
  faChartPie,
  faFile,
  faUnlock,
} from '@fortawesome/free-solid-svg-icons'
import React, { useContext } from 'react'
import { Navigation, Responsive } from 'ui'

export const AdminDashboardView: React.FC = () => {
  const { useDisplayMode } = useContext(Responsive.DrawerManagerContext)
  useDisplayMode('expanded')
  return (
    <div className="flex flex-wrap w-full m-1 sm:m-2 mb-auto sm:mb-auto md:w-3/4">
      <Navigation.MainMenuButton
        to="/admin/profiles/"
        label="Profiles"
        icon={faUsers}
      />
      <Navigation.MainMenuButton
        to="/admin/events/"
        label="Events"
        icon={faCalendar}
      />
      {/* <Navigation.MainMenuButton
        to="/admin/invitations/"
        label="Invitations"
        icon={faCalendarCheck}
      /> */}
      {/* <Navigation.MainMenuButton
        to="/admin/resources/"
        label="Resources"
        icon={faFile}
      /> */}
      <Navigation.MainMenuButton
        to="/admin/reports/"
        label="Reports"
        icon={faChartPie}
      />
      <Navigation.MainMenuButton
        to="/admin/roles/"
        label="Admin Roles"
        icon={faUnlock}
      />
    </div>
  )
}
